import type { CompanyDuplicateDto, GetCompanyDto } from '@api/customers'
import { ACTIVE_SPEC_NAME } from '@common/utils'
import type { Dispatch, SetStateAction } from 'react'
import type { SelectedRecordsType } from './types'

export const reorderDefaultCustomerInfo = (
  customer: GetCompanyDto,
  setCustomer: Dispatch<SetStateAction<GetCompanyDto>>
) => {
  const defaultDeliveryLocationId = customer.defaultDeliveryLocationId
  const defaultContactId = customer.defaultContactId
  const defaultBillingAddressId = customer.defaultBillingAddressId

  // Reorder the deliveryLocations array
  const updatedDeliveryLocations = [...(customer.deliveryLocations ?? [])]
  const defaultDeliveryLocationIndex = updatedDeliveryLocations.findIndex(
    location => location.id === defaultDeliveryLocationId
  )

  if (
    defaultDeliveryLocationIndex !== -1 &&
    defaultDeliveryLocationIndex !== 0
  ) {
    const defaultDeliveryLocation = updatedDeliveryLocations.splice(
      defaultDeliveryLocationIndex,
      1
    )[0]

    updatedDeliveryLocations.unshift(defaultDeliveryLocation)
  }

  // Reorder the companyContact array
  const updatedCompanyContact = [...(customer.companyContact ?? [])]
  const leadContactIndex = updatedCompanyContact.findIndex(
    contact => contact.isLeadContact
  )
  const leadContact =
    leadContactIndex !== -1
      ? updatedCompanyContact.splice(leadContactIndex, 1)[0]
      : null

  const defaultContactIndex = updatedCompanyContact.findIndex(
    contact => contact.id === defaultContactId
  )

  if (defaultContactIndex !== -1 && defaultContactIndex !== 0) {
    const defaultContact = updatedCompanyContact.splice(
      defaultContactIndex,
      1
    )[0]

    updatedCompanyContact.unshift(defaultContact)
  }

  if (leadContact) {
    updatedCompanyContact.unshift(leadContact)
  }

  // Reorder the companyBillingAddresses array
  const updatedCompanyBillingAddresses = [
    ...(customer.companyBillingAddresses ?? [])
  ]
  const defaultBillingAddressIndex = updatedCompanyBillingAddresses.findIndex(
    address => address.id === defaultBillingAddressId
  )

  if (defaultBillingAddressIndex !== -1 && defaultBillingAddressIndex !== 0) {
    const defaultBillingAddress = updatedCompanyBillingAddresses.splice(
      defaultBillingAddressIndex,
      1
    )[0]

    updatedCompanyBillingAddresses.unshift(defaultBillingAddress)
  }

  setCustomer({
    ...customer,
    companyBillingAddresses: updatedCompanyBillingAddresses,
    companyContact: updatedCompanyContact,
    deliveryLocations: updatedDeliveryLocations
  })
}

export const createConfirmMergePayload = (
  selectedCustomers: CompanyDuplicateDto[],
  selectedRecords: SelectedRecordsType
) => {
  const companiesIds = selectedCustomers.map(customer => customer.id)
  const billingAddressesIds = selectedRecords.companyBillingAddresses.map(
    record => record.id
  )
  const deliveryAddressesIds = selectedRecords.deliveryLocations.map(
    record => record.id
  )
  const contactsIds = selectedRecords.companyContact.map(record => record.id)

  return {
    selectedCompaniesIds:
      companiesIds.length > 0 ? (companiesIds as number[]) : null,
    selectedBillingAddressesIds:
      billingAddressesIds.length > 0 ? (billingAddressesIds as number[]) : null,
    selectedDeliveryLocationsIds:
      deliveryAddressesIds.length > 0
        ? (deliveryAddressesIds as number[])
        : null,
    selectedCompanyContactIds:
      contactsIds.length > 0 ? (contactsIds as number[]) : null
  }
}

export const storeActiveSpecName = (name?: null | string) =>
  sessionStorage.setItem(ACTIVE_SPEC_NAME, name?.toString() ?? '')
